import { CaretDownOutlined } from "@ant-design/icons";
import { Select } from "antd";
import _ from "lodash";
import React from "react";

export interface IFeatureSelectProps {
  options: any[] | null;
  currentValue: any;
  handleOnChange: Function | null;
  is_need_dropdown_features: boolean;
  is_label_dropdown: boolean;
  is_special_category: boolean;
  is_hide_thick_dropdown: boolean;
  is_normal_dropdown: boolean;
}

const FeatureSelect = (props: IFeatureSelectProps) => {
  const {
    options,
    currentValue,
    handleOnChange,
    is_need_dropdown_features,
    is_label_dropdown,
    is_special_category,
    is_hide_thick_dropdown,
  } = props;

  const PropertySelectFeature = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}>
        {currentValue?.wide &&
        currentValue?.long &&
        currentValue?.thick &&
        is_need_dropdown_features &&
        !is_label_dropdown &&
        !is_special_category ? (
          <span className="section-product-select__size">
            {currentValue?.wide / 10} x {currentValue?.long / 10} x{" "}
          </span>
        ) : null}
        <Select
          virtual={false}
          value={currentValue.value}
          onChange={handleOnChange}
          className={`product-item-select ${
            !is_special_category && !is_label_dropdown
              ? "product-item-select--right"
              : "product-item-select--left"
          }`}
          dropdownClassName="product-item-select__dropdown"
          suffixIcon={
            <CaretDownOutlined
              style={{
                color: "#0c3b5d",
              }}
              className="flicker-color"
            />
          }>
          {options && options.length
            ? _.sortBy(options, [!is_special_category ? "thick" : "wide"]).map(
                (item: any, index: number) => (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    // className="section-product-select-spec-option"
                    className="product-item-select__option">
                    <span className="product-item-select__label">
                      {item.thick &&
                      is_need_dropdown_features &&
                      !is_label_dropdown
                        ? !is_special_category
                          ? `${item.thick / 10} cm`
                          : `${item.wide / 10} x ${item.long / 10} `
                        : item.label}
                    </span>
                  </Select.Option>
                )
              )
            : null}
        </Select>
        {is_special_category && is_need_dropdown_features ? (
          <span className="section-product-select__thick">
            {!is_hide_thick_dropdown
              ? `x ${currentValue?.thick / 10} cm`
              : "cm"}
          </span>
        ) : null}
      </div>
    );
  };

  return (
    <>
      {!is_need_dropdown_features ? (
        <p className="product-item__property-label">
          {currentValue.label || currentValue.spec}
        </p>
      ) : (
        PropertySelectFeature()
      )}
    </>
  );
};

export default FeatureSelect;
